const AppConfig = {
  install(Vue, options) {
    Vue.prototype.$app = {
      name: 'Foodie',
    };
    Vue.prototype.$flags = {
      noBreakfast: true,
    };
  },
};

export default AppConfig;



//////////////////
// WEBPACK FOOTER
// ./config/appConfig.js
// module id = null
// module chunks = 